import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-share-receiver' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const ShareReceiver = NativeModules.ShareReceiver
  ? NativeModules.ShareReceiver
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

export function dismiss(error) {
  ShareReceiver.dismiss(error);
}

export function getSharedData() {
  return ShareReceiver.getSharedData();
}

export function openApp() {
  if (Platform.OS === 'ios') {
    ShareReceiver.openApp();
  }
}
